import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// COMPONENTS
import { AlternateIdsComponent } from 'v2/modules/shared/components/alternate-ids/alternate-ids.component';
import { NgxPermissionsModule } from 'ngx-permissions';

import { FeatureModule } from 'v2/shared/feature/feature.module';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { PurchaseOrderModule } from '../purchase-order/purchase-order.module';
import { UiModule } from '../ui/ui.module';

// MODULES
import { DirectiveModule } from './../shared/directives/directive.module';
import { PipeModule } from './../shared/pipes/pipe.module';
import { ReceivingReportUnifiedFormComponent } from './components';

// PIPES
import { ReceivingReportEnableBinAndLotTrackingPipe } from './pipes';

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  ScrollingModule,
];

const libModules = [NgxPermissionsModule];

const standAloneComponents = [
  AlternateIdsComponent
];

const lumModules = [
  PipeModule,
  MaterialCustomModule,
  UiModule,
  DirectiveModule,
  PurchaseOrderModule,
  SharedComponentsModule,
  FeatureModule,
];

const components = [ReceivingReportUnifiedFormComponent];

const pipes = [ReceivingReportEnableBinAndLotTrackingPipe];

@NgModule({
  declarations: [...components, ...pipes],
  imports: [...angularModules, ...lumModules, ...libModules, ...standAloneComponents],
  exports: [...components, ...pipes],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ReceivingReportModule {}
